module.exports = __webpack_public_path__ + "static/media/ether.ea25e0dd.webp";